import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import screenfull from 'screenfull';
import ReactPlayer from 'react-player';

import './reset.css';
import './defaults.css';
import './range.css';
import './App.css';
import './remixicon/remixicon.css'


class App extends Component{
   state = {
    url: null,
    pip: false,
    playing: true,
    controls: false,
    light: false,
    volume: 0,
    muted: true,
    played: 0,
    loaded: 0,
    duration: 0,
    playbackRate: 1.0,
    loop: false,
	fullscreen: false,
	size:'contain'
  };
	

  load = url => {
    this.setState({
      url,
      played: 0,
      loaded: 0,
      pip: false
    })
  }
 

  handlePlayPause = () => {
    this.setState({ playing: !this.state.playing })
	  console.log('999'+this.state.playing);
  }

  handleStop = () => {
    this.setState({ url: null, playing: false })
  }

  handleToggleControls = () => {
    const url = this.state.url
    this.setState({
      controls: !this.state.controls,
      url: null
    }, () => this.load(url))
  }

  handleToggleLight = () => {
    this.setState({ light: !this.state.light })
  }

  handleToggleLoop = () => {
    this.setState({ loop: !this.state.loop })
  }

  handleVolumeChange = e => {
   // this.setState({ volume: parseFloat(e.target.value) })
	  if(parseFloat(e.target.value) === 0) {
		  this.setState({ muted: true, volume: parseFloat(e.target.value)})
	  } else {
		  this.setState({ muted: false, volume: parseFloat(e.target.value)})
	  }
  }

  handleToggleMuted = () => {
	if(this.state.muted) {
    	this.setState({ muted: !this.state.muted, volume: 0.8 })
	} else {
    	this.setState({ muted: !this.state.muted, volume: 0 })	
	}

  }

  handleSetPlaybackRate = e => {
    this.setState({ playbackRate: parseFloat(e.target.value) })
  }

  handleTogglePIP = () => {
    this.setState({ pip: !this.state.pip })
  }

  handlePlay = () => {
    console.log('onPlay')
    this.setState({ playing: true })
  }

  handleEnablePIP = () => {
    console.log('onEnablePIP')
    this.setState({ pip: true })
  }

  handleDisablePIP = () => {
    console.log('onDisablePIP')
    this.setState({ pip: false })
  }

  handlePause = () => {
    console.log('onPause')
    this.setState({ playing: false })
  }

  handleSeekMouseDown = e => {
    this.setState({ seeking: true })
  }

  handleSeekChange = e => {
    this.setState({ played: parseFloat(e.target.value) })
  }

  handleSeekMouseUp = e => {
    this.setState({ seeking: false })
    this.player.seekTo(parseFloat(e.target.value))
  }

  handleProgress = state => {
    console.log('onProgress', state)
    // We only want to update time slider if we are not currently seeking
    if (!this.state.seeking) {
      this.setState(state)
    }
  }

  handleEnded = () => {
    console.log('onEnded')
    this.setState({ playing: this.state.loop })
  }

  handleDuration = (duration) => {
    console.log('onDuration', duration)
    this.setState({ duration })
  }

  handleClickFullscreen = () => {
    //screenfull.request(findDOMNode(this.player))
	if(this.state.fullscreen) {
		this.setState({ fullscreen: false })
	} else {
		this.setState({ fullscreen: true })
	}
	screenfull.toggle(findDOMNode(document.getElementById('app')))
  }
  
  handlePlayerSize = () => {
	 if(this.state.size === 'contain') {
		this.setState({ size: 'cover' })
	} else {
		this.setState({ size: 'contain' })
	} 
  }
  
  handleError = (e) => {
     console.log('----- onError');
     console.log('onError', e);
	 /* 
	 var element = document.getElementById('root');
	 element.classList.add('hlsError');
	 
	 if(e === 'hlsError') {
		 setInterval(function() {
			window.location = window.location.href;
		 }, 10000);
	 }
	 */
	  
  }

  renderLoadButton = (url, label) => {
    return (
      <button onClick={() => this.load(url)}>
        {label}
      </button>
    )
  }
  
  

  ref = player => {
    this.player = player
  }	
	
  render () {
	const search = window.location.search;
	const params = new URLSearchParams(search);
	const streamEncoded = params.get('stream');
	const streamCustom = params.get('custom');
	const stream = window.atob(streamEncoded);

    const { playing, controls, light, volume, muted, loop, played, loaded, playbackRate, pip, fullscreen, size} = this.state
	  
	const pauseButton = '<i class="ri-pause-fill"></i>'
	const playButton = '<i class="ri-play-fill"></i>'
	const fullscreenButton = '<i class="ri-fullscreen-fill"></i>'
	const exitfullscreenButton = '<i class="ri-fullscreen-exit-fill"></i>'
	const sizeButton = '<i class="ri-swap-box-fill"></i>'
	
	const pipButtonON = '<i class="ri-picture-in-picture-2-fill"></i>'
	const pipButtonOFF = '<i class="ri-picture-in-picture-exit-fill"></i>'
	
	
	let boxClass = ["app"];
    if(size === 'cover') {
      boxClass.push('cover');
    } else {
	  boxClass.push('contain');
	}
	  
	if(streamCustom === 'pixel') {
      boxClass.push('custom-ctv');
    } 
	  
	if(streamCustom === 'ebu') {
      boxClass.push('custom-ebu');
    } 
	 
	   
	var allowView = false;  
	
	//var parentWindow = window.parent.location;
	//parentWindow = parentWindow.toString();  
	  
	//console.log('------'+navigator.userAgent.includes('Firefox')); 
	//var pathArray = parentWindow.split ( '/' );
	//console.log(pathArray[0]); 
	  
	//console.log(window.location);
	if (window.location !== window.parent.location )
    {
		//console.log(" --- "+window.location);
        // The page is in an iFrames
        //console.log("The page is in an iFrame");
		

		if(navigator.userAgent.includes('Firefox') === false) {
			const ancestorOrigins = window.location.ancestorOrigins[0]
			const XFRAME_WHITELIST = [ 'https://letscast.video', 'https://d9.letscast.video', 'https://drupal9.letscast.video', 'https://icdn.video', 'https://ebu.icdn.video', 'https://pixel.click-to-video.com', 'https://zimzim.video', 'https://pe.we2.video', 'https://eu.we2.video', 'https://isocialtv.com', 'https://in.we2.video', 'https://we2.video', 'https://netstairs.com' ];
			if (XFRAME_WHITELIST.indexOf(ancestorOrigins) !== -1) {
				allowView = true;  
			} else {
				boxClass.push('error-message');
			}
		}

    }
    else {
        // The page is not in an iFrame
       console.log("The page is not in an iFrame");
		boxClass.push('error-message');

    }
	allowView = true; 
	 //console.log(allowView);
	  
//<iframe src='https://player.twitch.tv?autoplay=true&amp;channel=solorenektononly&amp;controls=true&amp;height=100%25&amp;migration=true&amp;muted=true&amp;parent=letscast.video&amp;playsinline=true&amp;'></iframe>
	if(allowView === true) {
    return (

		
      <div className={boxClass.join(' ')} id='app'>
		

        <ReactPlayer
          ref={this.ref}
          className='player-container'
          width='100%'
          height='100%'
          url={stream}
          pip={pip}
          playing={playing}
          controls={controls}
          light={light}
          loop={loop}
          playbackRate={playbackRate}
          volume={volume}
          muted={muted}
          onReady={() => console.log('onReady')}
          onStart={() => console.log('onStart')}
          onPlay={this.handlePlay}
          onEnablePIP={this.handleEnablePIP}
          onDisablePIP={this.handleDisablePIP}
          onPause={this.handlePause}
          onBuffer={() => console.log('onBuffer')}
          onSeek={e => console.log('onSeek', e)}
          onEnded={this.handleEnded}
          onError={e => this.handleError(e)} 
          onProgress={this.handleProgress}
          onDuration={this.handleDuration}
          config={{
			twitch: {
			  options: {
				  parent: ["letscast.video", "letstream.video", "player.letscast.video"]
			  }
			}
		  }}
        />
		

        <div className='player-controls'>
			<div className="player-buttons-left">
				{streamCustom === 'ebu' 
				? <div className='player-custom-logo logo-ebu' title='European Broadcasting Union' ><span>EBU</span></div>
				: ''
				}
				<button className='player-playpause-button' onClick={this.handlePlayPause}>{playing ?  <span dangerouslySetInnerHTML={{ __html: pauseButton }} /> : <span dangerouslySetInnerHTML={{ __html: playButton }} />}</button>
				<input id='muted' type='checkbox'  className='player-muted-button' checked={muted} onChange={this.handleToggleMuted} />
				<div className='player-volume-progress'>
					<input type='range' min={0} max={1} className='player-volume' step='any' value={volume} onChange={this.handleVolumeChange} />
					<progress max={1} value={volume} className='player-volume-value'/>
				</div>
			</div>

			<div className='player-progress'>
				<input
                    type='range' min={0} max={0.999999} step='any'
                    value={played}
                    onMouseDown={this.handleSeekMouseDown}
                    onChange={this.handleSeekChange}
                    onMouseUp={this.handleSeekMouseUp}
 					className='player-progress-seek'
                  />
				<progress max={1} value={played} className='player-progress-played'/>		
				<progress max={1} value={loaded} className='player-progress-loaded'/>		
			</div>

			<div className="player-buttons-right">
				<button className='player-size-button' onClick={this.handlePlayerSize}><span dangerouslySetInnerHTML={{ __html: sizeButton }} /></button>
{ReactPlayer.canEnablePIP(stream) && <button className='player-pip' onClick={this.handleTogglePIP}> { pip ? <span dangerouslySetInnerHTML={{ __html: pipButtonOFF }} /> : <span dangerouslySetInnerHTML={{ __html: pipButtonON }} /> }</button> }	
				{streamCustom !== 'pixel' 
				? <button className='player-fullscreen-button' onClick={this.handleClickFullscreen}>{fullscreen ?  <span dangerouslySetInnerHTML={{ __html: exitfullscreenButton }} /> : <span dangerouslySetInnerHTML={{ __html: fullscreenButton }} />}</button>
				: ''
				}

				

			</div>
			
			
			
        </div>
      </div>
    )
	
	} else {
		 return (
      		<div className={boxClass.join(' ')} id='app'><h2>ACCESS DENIED</h2></div> 
			 )
		
	}
	
  }
}
/*
App.use(function(req, res, next) {
  res.header("Access-Control-Allow-Origin", "*");
  res.header("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept");
  next();
});
*/
export default App;


/*
<a href="https://letscast.video/" target="_blank" rel="noopener noreferrer" id="logo">
<i className="ri-chat-voice-fill"></i><span className="pulse"></span>
</a>
*/
